 $(document).ready(function () {
    
        const parallaxElements = document.querySelectorAll('[data-parallax]');
        window.addEventListener('scroll', () => {
            const y = window.scrollY;
            parallaxElements.forEach((el) => {
                const top = el.offsetTop;
                var val = (y > top) ? y / 70 : 0;
                if (screen.width > 992) {
                    el.style.transform = "translate3d(0, " + val + "vh, 0) scale(1.2)";
                } else if (screen.width > 768) {
                    el.style.transform = "translate3d(0, " + val + "vh, 0) scale(1.4)";
                } else if (screen.width > 500) {
                    val = (y > top) ? y / 90 : 0;
                    el.style.transform = "translate3d(0, " + val + "vh, 0) scale(1.5)";
                } else {
                    val = (y > top) ? y / 100 : 0;
                    console.log(val)
                    el.style.transform = "translate3d(0, " + val + "vh, 0) scale(2.5)";
                }
            });
        });


		 $('.bf_cruching_wrapper').owlCarousel({
            loop: true,
            margin: 80,
            nav: false,
            navText: ['', ''],
            dots: false,
            autoplay: true,
            smartSpeed: 2000,
            autoplayTimeout: 2000,  
            responsive: {
                0: {
                    items: 2
                },
                400: {
                    items: 2
                },
                768: {
                    items: 4
                },
                992: {
                  items: 5, margin: 100
                }
            }
        })  
        
        
//         $(".bf_mobile_nav_dropdown").click(function (e) {
//             e.preventDefault();
//             $(".bf_mobile_nav_dropdown").not($(this)).removeClass('active').find('.bf_mobile_nav_sublist_content').slideUp();
          	
// //           	         console.log($(this).removeClass('active').find('.bf_mobile_nav_sublist_content')) 
          
//             $(this).find('.bf_mobile_nav_sublist_content').slideToggle();
//              $(this).toggleClass('active');

//         });




//         $(window).resize(function () {
//             f();
//         })

//         function f() {
//             let media = window.matchMedia('(max-width: 768px)');
//             if (media.matches) {
//                 $(".bf_see_in_sec").wrap("<div class='bf_overflow_scroll dragscroll'></div>")
//                 // $( "<div class='bf_overflow_scroll dragscroll'></div>" ).insertBefore( ".inner" );
//             }
//         }

//         f();


    });


